import { computed, ref, watch } from 'vue';
import { defineStore } from 'pinia';

export type FilmThemeMode = 'light' | 'dark';

const THEME_STORAGE_KEY = 'film_theme_mode';

export const useThemeStore = defineStore('theme', () => {
  const storedMode = localStorage.getItem(THEME_STORAGE_KEY);
  const mode = ref<FilmThemeMode>(storedMode === 'dark' ? 'dark' : 'light');
  const isDark = computed(() => mode.value === 'dark');

  watch(
    mode,
    (value) => {
      localStorage.setItem(THEME_STORAGE_KEY, value);
      document.documentElement.classList.toggle(
        'film-theme-dark',
        value === 'dark',
      );
      document.documentElement.style.colorScheme =
        value === 'dark' ? 'dark' : 'light';
    },
    { immediate: true },
  );

  return { mode, isDark };
});
